<button [id]="idVal" type="button" (click)="onClick.emit($event)" class="btn st-button-white rounded-pill">
  {{label}}
</button>
